import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { MeuPerfilComponent } from './meu-perfil.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: MeuPerfilComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MeuPerfilRoutingModule { }
